import React, { useState } from 'react'
import { useTranslations } from 'next-intl'
import { createClient } from '@/lib/supabase/client'
import { Icon } from '@iconify/react/dist/iconify.js'

const SocialSignIn = () => {
  const t = useTranslations('SignIn')
  const [loading, setLoading] = useState(false)

  const handleGoogleSignIn = async () => {
    setLoading(true)
    const supabase = createClient()
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}/auth/callback`,
      },
    })
  }

  return (
    <div className='flex gap-4'>
      <button
        type='button'
        onClick={handleGoogleSignIn}
        disabled={loading}
        className='flex w-full items-center justify-center gap-2.5 rounded-xl p-3.5 border border-gray-200 text-black hover:bg-neutral-100 hover:cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed'>
        {loading && <Icon icon='mdi:loading' width={18} height={18} className='animate-spin' />}
        {t('signInWithGoogle')}
        <svg
              width='23'
              height='22'
              viewBox='0 0 23 22'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <g clipPath='url(#clip0_709_8846)'>
                <path
                  d='M22.5001 11.2438C22.5134 10.4876 22.4338 9.73256 22.2629 8.995H11.7246V13.0771H17.9105C17.7933 13.7929 17.5296 14.478 17.1352 15.0914C16.7409 15.7047 16.224 16.2335 15.6158 16.646L15.5942 16.7827L18.9264 19.3124L19.1571 19.335C21.2772 17.4161 22.4997 14.5926 22.4997 11.2438'
                  fill='#4285F4'
                />
                <path
                  d='M11.7245 22C14.755 22 17.2992 21.0221 19.1577 19.3355L15.6156 16.6464C14.6679 17.2944 13.3958 17.7467 11.7245 17.7467C10.3051 17.7385 8.92433 17.2926 7.77814 16.472C6.63195 15.6515 5.77851 14.4981 5.33892 13.1755L5.20737 13.1865L1.74255 15.8142L1.69727 15.9376C2.63043 17.7602 4.06252 19.2925 5.83341 20.3631C7.60429 21.4337 9.64416 22.0005 11.7249 22'
                  fill='#34A853'
                />
                <path
                  d='M5.33889 13.1755C5.09338 12.4753 4.96669 11.7404 4.96388 11C4.9684 10.2608 5.09041 9.52685 5.32552 8.8245L5.31927 8.67868L1.81196 6.00867L1.69724 6.06214C0.910039 7.5938 0.5 9.28491 0.5 10.9999C0.5 12.7148 0.910039 14.406 1.69724 15.9376L5.33889 13.1755Z'
                  fill='#FBBC05'
                />
                <path
                  d='M11.7249 4.25337C13.3333 4.22889 14.8888 4.8159 16.065 5.89121L19.2329 2.86003C17.2011 0.992106 14.5106 -0.0328008 11.7249 3.27798e-05C9.64418 -0.000452376 7.60433 0.566279 5.83345 1.63686C4.06256 2.70743 2.63046 4.23965 1.69727 6.06218L5.32684 8.82455C5.77077 7.50213 6.62703 6.34962 7.77491 5.5295C8.9228 4.70938 10.3044 4.26302 11.7249 4.25337Z'
                  fill='#EB4335'
                />
              </g>
              <defs>
                <clipPath id='clip0_709_8846'>
                  <rect width='22' height='22' fill='white' transform='translate(0.5)' />
                </clipPath>
              </defs>
            </svg>
      </button>
    </div>
  )
}

export default SocialSignIn
